// src/supabase/schema.ts
//
// The Postgres schema this app's tables live in (`pit` on SCR Central).
//
// Fails closed. On the shared database a bare table name resolves to `public`,
// which holds SCR Central's own people data and belongs to other applications.
// An unset or `public` value must therefore never be accepted silently: reads
// and writes would succeed against the wrong schema instead of erroring.
// (Directory migration Step 0; scr-central#222, audit hazard H2.)
export function resolveAppSchema(raw: string | undefined): string {
  const schema = raw?.trim()
  if (!schema || schema === 'public') {
    throw new Error('VITE_SUPABASE_DB_SCHEMA must be set to the app schema (not public)')
  }
  return schema
}
